import { BookingIntegrated } from '@modules/Booking/components/BookingIntegrated';

export default function Offer() {
  return <BookingIntegrated mode="OFFER" />;
}
